import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import pinsReducer from '../features/senninha/pinsSlice'
import hubsSelector from '../features/senninha/hubsSlice';
import angelsReducer from '../features/senninha/angelsSlice';
import routesManagementReducer from '../features/senninha/routesManagementSlice';
import trackingDeliveriesReducer from '../features/senninha/trackingDeliveriesSlice';
import optionsReducer from '../features/optionsSlice';
import ticketReducer from '../features/senninha/ticketSlice';
import riskAreasReducer from '../features/senninha/riskAreasSlice'
import oldSenninhaReducer from '../features/senninha/oldSenninhaSlice'
import preDeliveryFormReducer from '../features/senninha/preDeliveryFormSlice'
import trackingRoutesReducer from '../features/senninha/trackingRoutesSlice';
import frequencyHistoricReducer from '../features/senninha/GestaoEquipe/frequencyHistoricSlice';
import unproductivityJustificationReducer from '../features/senninha/GestaoEquipe/unproductivityJustificationSlice';
import zipCodeAddressInformationReducer from '../features/senninha/zipCodeAddressInformationSlice';
import providerInformationsReducer from '../features/senninha/GestaoEquipe/providerInformationsSlice';
import employeesInfosLogisticReducer from '../features/senninha/employeesInfosLogistic';
import inventoryAuditReducer from '../features/anexos/inventoryAuditSlice';
import attachmentReducer from '../features/anexos/attachmentSlice';
import adminStoneEntregaReducer from '../features/adminStoneEntrega/adminStoneEntregaSlice';
import polygonReducer from '../features/senninha/polygonsSlice';


const rootPersistorConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: ['adminStoneEntregaSlice'] //If you don’t want to persist a part of your state you could put it in the blacklist. example => blacklist: [pinsSlice]
};

const rootReducer = combineReducers({
    pinsSlice: pinsReducer,
    hubsSlice: hubsSelector,
    angelsSlice: angelsReducer,
    routesManagementSlice: routesManagementReducer,
    trackingDeliveriesSlice: trackingDeliveriesReducer,
    optionsSlice: optionsReducer,
    ticketSlice: ticketReducer,
    riskAreasSlice: riskAreasReducer,
    oldSenninhaSlice: oldSenninhaReducer,
    preDeliveryFormSlice: preDeliveryFormReducer,
    trackingRoutesSlice: trackingRoutesReducer,
    employeesInfosLogisticSlice: employeesInfosLogisticReducer,
    //Gestao de Equipe
    frequencyHistoricSlice: frequencyHistoricReducer,
    unproductivityJustificationSlice: unproductivityJustificationReducer,
    zipCodeAddressInformationSlice: zipCodeAddressInformationReducer,
    providerInformationsSlice: providerInformationsReducer,
    //Auditoria de Inventário
    inventoryAuditSlice: inventoryAuditReducer,
    attachmentSlice: attachmentReducer,
    adminStoneEntregaSlice: adminStoneEntregaReducer,
    polygonsSlice: polygonReducer,
});

const store = configureStore({
    reducer: persistReducer(rootPersistorConfig, rootReducer),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);
export default store;
